/* eslint-disable prefer-arrow-callback */
import React from 'react';
import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import { Button, CardActions, CardContent, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useFRCallback } from '@/hooks';

// NOTE: need to ensure that the goto url param is passed correctly in order to properly redirect to the settings app if needed
const SecurityQuestionsConfirmation = ({ ...props }) => {
  const { stepToRender, setCurrentStep } = props;

  const { callbacks = [], confirmationCallbackIndex, confirmationCallbackOptions } = useFRCallback(stepToRender);

  const handleNavigation = () => {
    // get the index of the 'yes' option and set the new callbacks accordingly
    const output = { ...stepToRender };

    const newCallbacks = [...callbacks];
    const indexToUse = findIndex(confirmationCallbackOptions, (optionValue) => optionValue?.toLowerCase() === 'yes');

    if (indexToUse) {
      newCallbacks[confirmationCallbackIndex].input = [
        {
          ...newCallbacks[confirmationCallbackIndex].input[0],
          value: indexToUse,
        },
      ];
    }

    Object.assign(output.payload.callbacks, [...newCallbacks]);

    setCurrentStep({ ...output });
  };

  return (
    <Grid
      id="security-questions-confirmation-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid
        size={{ xs: 12, sm: 12, md: 6 }}
        display="flex"
        flexDirection="column"
        alignItems="center"
        flexGrow={1}
        sx={{ minHeight: '100vh' }}
      >
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '500px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                Security Questions
              </Typography>
              <Typography variant="subtitle1" mb={5}>
                Your security questions have been saved.
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'end' }}>
              <Button color="primary" onClick={handleNavigation}>
                Continue
              </Button>
            </CardActions>
          </Paper>
        </Grid>
        <Footer />
      </Grid>
    </Grid>
  );
};

SecurityQuestionsConfirmation.propTypes = {
  stepToRender: PropTypes.object.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
};

export default SecurityQuestionsConfirmation;
